import { render, staticRenderFns } from "./SectionPrice.vue?vue&type=template&id=9a174c18&scoped=true&"
import script from "./SectionPrice.vue?vue&type=script&lang=js&"
export * from "./SectionPrice.vue?vue&type=script&lang=js&"
import style0 from "./SectionPrice.vue?vue&type=style&index=0&id=9a174c18&lang=scss&scoped=true&"
import style1 from "./SectionPrice.vue?vue&type=style&index=1&id=9a174c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a174c18",
  null
  
)

export default component.exports